export default {"src":"/_next/static/media/plus.18c49488.svg","height":513,"width":513};